interface Realms {
  NA: string;
  EU: string;
  FE: string;
}

export const REALMS: Realms = { NA: "na", EU: "eu", FE: "fe" };

// Reference https://code.amazon.com/packages/PVAccountingCDK/blobs/mainline/--/lib/marketplaces.ts
export const MARKETPLACE_TO_REALM: Record<string, string> = {
  A39IBJ37TRP1C6: REALMS.FE, // AUSTRALIA_PROD
  A1RNPCQ4K8U27I: REALMS.FE, // AUSTRALIA_ DEVO
  AMEN7PMS3EDWL: REALMS.EU, // BELGIUM_PROD
  A1YFOMBPFBRY22: REALMS.EU, // BELGIUM_DEVO
  A2Q3Y263D00KWC: REALMS.NA, // BRAZIL_PROD
  AZXD3QD5B39HD: REALMS.NA, // BRAZIL_DEVO
  A2EUQ1WTGCTBG2: REALMS.NA, // CANADA
  A13V1IB3VIYZZH: REALMS.EU, // FRANCE
  A1PA6795UKMFR9: REALMS.EU, // GERMANY
  A21TJRUUN4KGV: REALMS.EU, // INDIA
  A2XZLSVIQ0F4JT: REALMS.EU, //INDIA_DEV
  APJ6JRA9NG5V4: REALMS.EU, // ITALY_PROD
  A3HOBANJMCMD83: REALMS.EU, // ITALY_DEVO
  A1VC38T7YXB528: REALMS.FE, // JAPAN
  A1AM78C64UM0Y8: REALMS.NA, // MEXICO_PROD
  A3P3J5A7D2ZVXI: REALMS.NA, // MEXICO_DEVO
  A1805IZSGTT6HS: REALMS.EU, // NETHERLANDS_PROD
  A1M3WC0SJ3A38T: REALMS.EU, // NETHERLANDS_DEVO
  A1C3SOZRARQ6R3: REALMS.EU, // POLAND_PROD
  AKY4K4WKH21YQ: REALMS.EU, // POLAND_DEVO
  A1RKKUPIHCS9HS: REALMS.EU, // SPAIN_PROD
  AJZF8LZ1EJVJN: REALMS.EU, // SPAIN_DEVO
  A3K6Y4MI8GDYMT: REALMS.EU, // ROE_EU_PROD
  A1MJEQWJOUEPEQ: REALMS.EU, // ROE_EU_DEVO
  A2MFUE2XK8ZSSY: REALMS.EU, // ROW_EU_PROD
  A1D7Z662KHSYZY: REALMS.EU, // ROW_EU_DEVO
  A15PK738MTQHSO: REALMS.FE, // ROW_FE_PROD
  A9QSUUOYRWVOG: REALMS.FE, // ROW_FE_DEVO
  ART4WZ8MWBX2Y: REALMS.NA, //  ROW_NA_PROD
  A3U49GLEJ1PS4Y: REALMS.NA, // ROW_NA_DEVO
  A2NODRKZP88ZB9: REALMS.EU, // SWEDEN_PROD
  AT614YYYNOC1S: REALMS.EU, // SWEDEN_DEVO
  A3CQBQD3RGPJR8: REALMS.EU, // TURKEY_DEVO
  A33AVAJ2PDY3EV: REALMS.EU, // TURKEY_PROD
  A34GYYCZVDBSIK: REALMS.EU, //UAE_DEVO
  A2VIGQ35RCS4UG: REALMS.EU, //UAE_PROD
  A1F83G8C2ARO7P: REALMS.EU, // UK
  ATVPDKIKX0DER: REALMS.NA, // US
};

export const MARKETPLACE_TO_COUNTRY_CODE: Record<string, string> = {
  A39IBJ37TRP1C6: "AU",
  A1RNPCQ4K8U27I: "AU_DEVO",
  AMEN7PMS3EDWL: "BE",
  A1YFOMBPFBRY22: "BE_DEVO",
  A2Q3Y263D00KWC: "BR",
  AZXD3QD5B39HD: "BR_DEVO",
  A2EUQ1WTGCTBG2: "CA",
  A1PA6795UKMFR9: "DE",
  A1RKKUPIHCS9HS: "ES",
  AJZF8LZ1EJVJN: "ES_DEVO",
  A13V1IB3VIYZZH: "FR",
  A1F83G8C2ARO7P: "GB",
  A21TJRUUN4KGV: "IN",
  A2XZLSVIQ0F4JT: "IN_DEVO",
  APJ6JRA9NG5V4: "IT",
  A3HOBANJMCMD83: "IT_DEVO",
  A1VC38T7YXB528: "JP",
  A1AM78C64UM0Y8: "MX",
  A3P3J5A7D2ZVXI: "MX_DEVO",
  A1805IZSGTT6HS: "NL",
  A1M3WC0SJ3A38T: "NL_DEVO",
  A1C3SOZRARQ6R3: "PL",
  AKY4K4WKH21YQ: "PL_DEVO",
  A3K6Y4MI8GDYMT: "ROE_EU_PROD",
  A1MJEQWJOUEPEQ: "ROE_EU_DEVO",
  A2MFUE2XK8ZSSY: "ROW_EU_PROD",
  A1D7Z662KHSYZY: "ROW_EU_DEVO",
  A15PK738MTQHSO: "ROW_FE_PROD",
  A9QSUUOYRWVOG: "ROW_FE_DEVO",
  ART4WZ8MWBX2Y: "ROW_NA_PROD",
  A3U49GLEJ1PS4Y: "ROW_NA_DEVO",
  A2NODRKZP88ZB9: "SE",
  AT614YYYNOC1S: "SE_DEVO",
  A3CQBQD3RGPJR8: "TR_DEVO",
  A33AVAJ2PDY3EV: "TR",
  A34GYYCZVDBSIK: "AE_DEVO",
  A2VIGQ35RCS4UG: "AE",
  ATVPDKIKX0DER: "US",
};

export const getCountryCodeFromMarketplace = (
  marketplaceId: string
): string => {
  return MARKETPLACE_TO_COUNTRY_CODE[marketplaceId] || "";
};

// ROW/ROE marketplaces are multi-country buckets (e.g. ROW_NA, ROE_EU) whose JEM files are keyed
// per buyer country rather than per bucket.
export const isPerCountryBucketMarketplace = (marketplace: string): boolean =>
  marketplace.startsWith("ROW") || marketplace.startsWith("ROE");

/**
 * Resolves the country code to send when triggering a shadow test.
 *
 * The marketplace-derived country is authoritative and wins over `declaredCountryCode`, which can
 * be wrong upstream (e.g. an FR order incorrectly tagged as DE) and would otherwise cause the wrong
 * JEM file to be selected. The one exception is ROW/ROE buckets: their JEMs are per-country, so the
 * declared (buyer) country is the correct key there and takes precedence.
 */
export const resolveShadowTestCountryCode = (
  marketplace: string,
  declaredCountryCode?: string,
  fallbackCountryCode?: string
): string => {
  if (isPerCountryBucketMarketplace(marketplace)) {
    return declaredCountryCode || fallbackCountryCode || marketplace;
  }
  return marketplace || declaredCountryCode || fallbackCountryCode || "";
};

// Reverse lookup: country code → marketplace ID (prod only)
export const COUNTRY_TO_MARKETPLACE: Record<string, string> =
  Object.fromEntries(
    Object.entries(MARKETPLACE_TO_COUNTRY_CODE)
      .filter(([, cc]) => !cc.includes("_"))
      .map(([mpId, cc]) => [cc, mpId])
  );

export const getRealmFromCountryCode = (countryCode: string): string => {
  const mpId = COUNTRY_TO_MARKETPLACE[countryCode];
  return mpId ? MARKETPLACE_TO_REALM[mpId] || REALMS.NA : REALMS.NA;
};
